const store = {
    countdownInterval: undefined
};

function updateSaleEndDateCountdown(state, shopList) {
    clearSaleEndDateCountdown(state);

    const saleEndDate = shopList?.saleEndDate;
    const distance = getDistanceInMilliSecond(saleEndDate);

    if (saleEndDate && distance && distance > 0) {
        state.saleEndDateDistance = distance;
        store.countdownInterval = setInterval(() => {
            state.saleEndDateDistance = getDistanceInMilliSecond(saleEndDate);
            if (state.saleEndDateDistance <= 0) {
                clearInterval(store.countdownInterval);
            }
        }, 1000);
    }
}

function clearSaleEndDateCountdown(state) {
    clearInterval(store.countdownInterval);

    state.saleEndDateDistance = 0;
}

function getDistanceInMilliSecond(date) {
    return date ? new Date(date) - new Date().getTime() : undefined;
}

export default {
    updateSaleEndDateCountdown,
    clearSaleEndDateCountdown
};
